var styleDataHash = "b41abc69";
const injectCss = () => {
  var css = `.glob_fontElementMap,.rR2gZ{font-family:var(--ricos-font-family,unset)}.lGsIh{width:100%}[dir] .lGsIh{margin:8px auto 0}.lGsIh .VD-t8{height:1px}[dir] .lGsIh .VD-t8{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.lGsIh .VD-t8{width:100%}[dir] .lGsIh .VD-t8{margin:0}}}@container (width < 640px){.lGsIh .VD-t8{width:100%}[dir] .lGsIh .VD-t8{margin:0}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_section_default = {
  "fontElementMap": "rR2gZ",
  "whitespace": "lGsIh",
  "divider": "VD-t8"
};
export {
  list_item_section_default as default,
  injectCss
};
//# sourceMappingURL=list-item-section-scss.js.map
